import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

import { NotificationBodyBase } from '../notification-body-base';
import { NotificationData } from '../notification-data';

@Component({
  selector: 'rt-notification-body',
  template: `
    <span *ngIf="title" class="title">{{ title }}</span>
    <span *ngIf="message" class="message">{{ message }}</span>
    <span *ngIf="messageHTML" class="message">
      <rt-text-swap [isHtml]="true" [text]="messageHTML"></rt-text-swap>
    </span>
    <rt-group *ngIf="actionButtonLabel" margin-top-small-x>
      <rt-button-new (click)="actionButtonClick.emit()" variant="secondary" margin-top>
        {{ actionButtonLabel }}
      </rt-button-new>
    </rt-group>
  `,
  styleUrls: ['./notification-body.component.less'],
})
export class NotificationBodyComponent extends NotificationBodyBase {
  @Input() public title?: string;
  @Input() public message?: string;
  @Input() public messageHTML?: string;
  @Input() public actionButtonLabel?: string;
  @Output() public actionButtonClick: EventEmitter<void> = new EventEmitter();

  /**
   * @deprecated
   */
  @Input() public data?: any;

  constructor(private _data: NotificationData, protected cdRef: ChangeDetectorRef) {
    super();

    this.title = _data.title;
    this.message = _data.message;
    this.messageHTML = _data.messageHTML;
    this.actionButtonLabel = _data.actionButtonLabel;
  }

  public setTitle(title: string): void {
    this.title = title;
    this.cdRef.detectChanges();
  }

  public setMessage(message: string): void {
    this.message = message;
    this.cdRef.detectChanges();
  }

  public setMessageHTML(messageHTML: string): void {
    this.messageHTML = messageHTML;
  }
}
